










import {defineComponent, PropType} from "@vue/composition-api";
import IRecipient from "@/apps/AwardsWidget/models/recipient";

export default defineComponent({
  name: "RecipientImageComponent",
  props: {
    recipient: {type: Object as PropType<IRecipient>, required: true}
  }
})
